import React from 'react';
import classnames from 'classnames';

const AccessibleLinks = ({ navId, contentId, footerId }) => {
  const wrapperClasses = classnames('accessible-links');

  const checkScrollTop = (target) => {
    return target.offsetTop - document.querySelector('.header').scrollHeight;
  };

  const findFocusable = (target) => {
    while (getComputedStyle(target, null).display === 'none') {
      target = target.nextSibling;
    }

    return target;
  };

  const scrollTo = (event) => {
    event.preventDefault();

    const target = findFocusable(
      document.querySelector(event.currentTarget.getAttribute('href'))
    );

    window.scrollTo({
      top: checkScrollTop(target),
      behavior: 'smooth',
    });

    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });

    return false;
  };

  const handleKeyDown = (evt) => {
    if (evt.key === 'Enter') {
      scrollTo(evt);
    }
  };

  return (
    <div className={wrapperClasses}>
      <a onClick={scrollTo} onKeyDown={handleKeyDown} href={'#' + navId}>
        Skip to Navigation
      </a>
      <a onClick={scrollTo} onKeyDown={handleKeyDown} href={'#' + contentId}>
        Skip to Content
      </a>
      <a onClick={scrollTo} onKeyDown={handleKeyDown} href={'#' + footerId}>
        Skip to Secondary Navigation
      </a>
    </div>
  );
};

export default AccessibleLinks;
